import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from 'src/app/modals/Authentication/auth.models';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './workflow-email-template.action';

@Injectable({ providedIn: 'root' })
export class WorkflowEmailTemplateTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                updated_at: '',
                is_active: null,
                email_title: '', 
                subject: '',
            };


    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'updated_at';
    initialSortDirection = 'asc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    statuses = [
        {"id": "1", "name": "COMMON.active"},
        {"id": "0", "name": "COMMON.inactive"}
    ];

    columns = [
                { prop: 'updated_at', name: 'COMMON.last-updated', sortable: true, hasFilter: true, filter: "date", widthSet: 180},
                { prop: 'email_title', name: 'WORKFLOW_EMAIL_TEMPLATE.field-title', sortable: false, hasFilter: false, filter: "input"},
                { prop: 'subject', name: 'WORKFLOW_EMAIL_TEMPLATE.subject', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'is_active', name: 'COMMON.status', sortable: true, hasFilter: true, filter: "select", options: 'statuses', options_id: "id", options_label: "name", widthSet: 180},
                { prop: 'actions', name: 'COMMON.actions', sortable: false, hasFilter: false, filter: "", widthSet: 180},
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords());
    }

    hasActiveFilters(){

        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetFilters(){
        this.filters = {
            updated_at: '',
            is_active: null,
            email_title: '',
            subject: '',
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;

        this.loadRecords();
    }

}